import { authorizedAxios } from "../../../Actions/AxiosActions";
import { INotification } from "../Models/Notification";
import { IGetNotificationsRequest } from "../Models/Requests/Notifications/GetNotificationsRequest";
import { IUpdateAllNotificationsActiveStatusRequest } from "../Models/Requests/Notifications/UpdateAllNotificationsActiveStatusRequest";
import { IUpdateAllNotificationsReadStatusRequest } from "../Models/Requests/Notifications/UpdateAllNotificationsReadStatusRequest";
import { IUpdateNotificationRequest } from "../Models/Requests/Notifications/UpdateNotificationRequest";

export async function setViewedByLinkId(linkId: string): Promise<INotification[]> {
    try {
        return await authorizedAxios(
            "PATCH",
            `/services/gps/Notifications/SetViewedByLinkId/${linkId}`,
            null,
            null);
    } catch (error) {
        throw error;
    }
}

export async function getNotifications(request: IGetNotificationsRequest): Promise<INotification[]> {
    try {
        return await authorizedAxios(
            "POST",
            "/services/gps/Notifications",
            null,
            request);
    } catch (error) {
        throw error;
    }
}

export async function updateNotification(request: IUpdateNotificationRequest): Promise<INotification> {
    try {
        return await authorizedAxios(
            "PATCH",
            "/services/gps/Notifications/Single",
            null,
            request
        );
    } catch (error) {
        throw error;
    }
}

export async function updateAllNotificationsReadStatus(request: IUpdateAllNotificationsReadStatusRequest): Promise<INotification> {
    try {
        return await authorizedAxios(
            "PATCH",
            "/services/gps/Notifications/All/ReadStatus",
            null,
            request
        );
    } catch (error) {
        throw error;
    }
}

export async function updateAllNotificationsActiveStatus(request: IUpdateAllNotificationsActiveStatusRequest): Promise<INotification> {
    try {
        return await authorizedAxios(
            "PATCH",
            "/services/gps/Notifications/All/ActiveStatus",
            null,
            request
        );
    } catch (error) {
        throw error;
    }
}
